export default "__VITE_ASSET__Cc28p23x__"